module.exports = __webpack_public_path__ + "media/images/icons/icon-drills-96e55b882e6e023208fc96025f55f97d.svg";